
export const THead = () => {
    return (
        <thead>
            <tr>
                <th>設定項目</th>
                <th>設定値</th>
                <th>現在値</th>
            </tr>
        </thead>
    )
}